import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(Settings.api.content, {
  get: {
    'onboarding.checkProgress':
      '/v1/onboarding/membership/:membershipId/progress'
  }
});

export default Request;
